import {
  SIGN_IN_BY_PASSWORD,
  SIGN_IN_BY_TOKEN,
  GET_TOKEN,
  UPDATE_TOKEN_TIMER,
  SIGN_OUT
} from "@/constants/actions";
import {
  UPDATE_TOKEN,
  UPDATE_REQUEST_ERROR,
  UPDATE_IS_AUTHORIZED,
  EMPTY_STATE
} from "@/constants/mutations";
import {
  parseJwt,
  isAccessExpired
} from "@/helpers/authentication";
// eslint-disable-next-line import/no-cycle
import { AuthenticationProvider } from "@/services/authentication/AuthenticationProvider";

let updateTokenTimeout = null;

const initialState = () => {
  const token = {
    refresh: window.localStorage.getItem("refreshToken") || null,
    access: null
  };
  const accessToken = window.localStorage.getItem("accessToken");

  if (accessToken && !isAccessExpired(accessToken)) {
    token.access = accessToken;
  }

  return {
    token,
    requestError: null,
    isAuthorized: false,
    isLoading: false
  };
};

const state = initialState();

const getters = {
  isAccessTokenSet: (state) => state.token?.access !== null,
  isRefreshTokenSet: (state) => state.token?.refresh !== null,
  decodedAccessToken: (state) => {
    const token = state.token?.access;

    if (token) {
      return parseJwt(token);
    } else {
      return null;
    }
  }
};

const mutations = {
  [UPDATE_TOKEN] (state, token) {
    state.token = { ...state.token, ...token };
  },

  [UPDATE_IS_AUTHORIZED] (state, isAuthorized) {
    state.isAuthorized = isAuthorized;
  },

  [UPDATE_REQUEST_ERROR] (state, error) {
    state.requestError = error;
  },

  [EMPTY_STATE] (state) {
    Object.assign(state, initialState());
  }
};

const actions = {
  async [SIGN_IN_BY_PASSWORD] (_, signInPayload) {
    await AuthenticationProvider.signInByPassword(
      signInPayload.login,
      signInPayload.password
    );
  },

  async [SIGN_IN_BY_TOKEN] ({ dispatch, getters }) {
    if (getters.isRefreshTokenSet) {
      if (!getters.isAccessTokenSet) {
        await dispatch(GET_TOKEN);
      }

      await AuthenticationProvider.signInByToken();

      dispatch(UPDATE_TOKEN_TIMER);
    }
  },

  async [GET_TOKEN] ({ state, dispatch }) {
    if (state.token?.refresh) {
      const token = await AuthenticationProvider.getFreshTokens(state.token.refresh);

      dispatch(UPDATE_TOKEN, token);
      dispatch(UPDATE_TOKEN_TIMER);
    }
  },

  [UPDATE_TOKEN] ({ commit }, token) {
    if (token.refresh) {
      window.localStorage.setItem("refreshToken", token?.refresh);
    }

    if (token.access) {
      window.localStorage.setItem("accessToken", token?.access);
    }

    commit(UPDATE_TOKEN, token);
  },

  [SIGN_OUT] ({ commit }) {
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("accessToken");

    commit(EMPTY_STATE);
  },

  [UPDATE_TOKEN_TIMER] ({ dispatch, getters }) {
    clearTimeout(updateTokenTimeout);

    if (getters.decodedAccessToken) {
      // Мы хотим обновить токен, через 80% от жизни токена, чтобы не получать ошибок протухшего токена.
      // 80% выбрано как оптимальный вариант.
      const lifetimePercent = 0.8;
      const accessTokenExpireTimeMilliseconds = getters.decodedAccessToken.exp * 1000;
      const accessTokenLifetime = accessTokenExpireTimeMilliseconds - Number(new Date());
      const accessTokenUpdateTimeout = Math.round(accessTokenLifetime * lifetimePercent);

      updateTokenTimeout = setTimeout(() => {
        dispatch(GET_TOKEN);
      }, accessTokenUpdateTimeout);
    }
  }
};

export const authentication = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
